export default {
  title: 'テーマ進行説明',
  mindMap: 'マインドマップ',
  documentTitle: '{name} テーマ進行説明',
  introduction: 'この文書には、各シーンのクリア判定条件、条件間の「かつ／または」の関係、およびクリア時のアクションをすべて記載しています。アクションはアクション行の順に並び、各行の遅延、パラメーター、アクション説明を含みます。',
  task: 'タスク {id}',
  mainTask: 'メインタスク',
  unassignedScenes: 'タスク未割り当てのシーン',
  scene: 'シーン {id}',
  unnamedScene: '名称未設定のシーン',
  sceneDescription: 'シーン説明：{description}',
  nextScenes: '次のシーン：{scenes}',
  sceneTiming: '開始後の判定遅延：{delay} 秒；タイムアウト：{timeout} 秒；タイムアウト時の自動スキップ：{skip}',
  yes: 'はい',
  no: 'いいえ',
  none: 'なし',
  and: 'かつ',
  or: 'または',
  notConfigured: '未設定',
  noCondition: '条件未設定',
  noConditionGroup: '条件グループ未設定',
  noPassCondition: 'クリア判定条件未設定',
  noPassConditionSentence: 'クリア判定条件は未設定です。',
  noAction: 'アクション未設定',
  noActionSentence: 'アクションは未設定です。',
  noPassAction: 'クリア時のアクション未設定',
  noPassActionSentence: 'クリア時のアクションは未設定です。',
  passConditions: 'クリア判定条件',
  passCheck: 'クリア判定',
  passActions: 'クリア時のアクション',
  action: 'アクション',
  actionBar: 'アクション行',
  conditionalAction: '条件付きアクション',
  conditionalPassAction: 'クリア時の条件付きアクション',
  trueActionBar: '条件成立時のアクション行',
  falseActionBar: '条件不成立時のアクション行',
  conditionMet: '条件成立',
  conditionNotMet: '条件不成立',
  executionCondition: '実行条件：{condition}',
  condition: '条件 {id}：{condition}',
  nextConditionRelation: '；次の条件と「{relation}」で接続',
  delay: '（遅延 {seconds} 秒）',
  colon: '：',
  comma: '、',
  semicolon: '；',
  actionSeparator: '、',
  parentheses: '（{text}）',
  quote: '「{text}」',
  conditionText: '{device}：{operation}',
  operationParameter: '{operation} {parameter}',
  deviceAction: '「{device}」{operation}',
  unknownDevice: '不明なデバイス',
  unknownAction: '不明なアクション',
  unknownCondition: '不明な条件：{condition}',
  emptyCondition: '空の条件',
  specifiedState: '指定状態に到達',
  targetScene: '対象シーン「{name}」（シーン {id}）',
  parameterValue: 'パラメーター値',
  brightness: '明るさ',
  volume: '音量',
  priority: '優先度',
  namedParameter: '{name}：「{value}」',
  additionalParameter: '追加パラメーター：「{value}」',
  parameterTarget: 'パラメーター対象ID：「{value}」',
  parameterHint: 'パラメーター説明：「{hint}」',
  priorityHint: '値が大きいほど優先度が高くなります',
  languageHint: '0 既定、1 中国語、2 広東語、3 英語、4 日本語、5 韓国語',
  actionDescription: '；アクション説明：「{description}」',
  nextSceneDescription: '次のシーン',
  noScenes: '現在のテーマにはエクスポートできるシーンがありません',
  waitForScenes: 'エクスポートできるシーンがありません。テーマデータの読み込み完了をお待ちください。',
  wordExported: 'テーマ進行の Word 文書をエクスポートしました',
  xmindExported: 'テーマ進行のマインドマップをエクスポートしました',
  exportFailed: 'テーマ進行のエクスポートに失敗しました。後でもう一度お試しください。',
}
